import * as React from 'react'
// libs
import styled from 'styled-components'
// themes
import colors from 'themes/colors'
// icons
import BlockIcon from '@mui/icons-material/Block'

const WarningMessageContainer = styled.div`
  flex-direction: column;
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  padding: 0 72px;
  width: 100%;

  > div {
    text-align: center;
    font-size: 20px;
    color: ${colors.gray300};
  }
`

interface Props {
  entityType?: string
}

const AuthorizationWarning: React.FC<Props> = ({ entityType = 'plan' }) => {
  return (
    <WarningMessageContainer>
      <BlockIcon sx={{ fontSize: 200, marginBottom: 2, color: colors.purple300 }} />
      <div>
        You are not authorised to view this {entityType}.
        <br />
        Please contact the {entityType} owner or your system administrator to request permission.
      </div>
    </WarningMessageContainer>
  )
}

export default AuthorizationWarning
